export default "__VITE_ASSET__C_x4vC3d__"